import {TypeOuiNon} from './TypeOuiNon';
export class MarcheNegocie {

	public candidatsDejaSelectionnes: TypeOuiNon;

	constructor() {
		 		this.candidatsDejaSelectionnes = new TypeOuiNon();

	}
}
